import styled from "styled-components";

export const ProductTableWrapper = styled.div`
  width: calc(100% - 32px);
  height: 477px;

  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 20px 0 0;
  flex-shrink: 0;

  position: relative;
`;

export const ProductTableTitle = styled.div`
  color: #000;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const ProductTableListWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;
  position: relative;
  align-items: center;
`;

export const ProductTableImage = styled.img`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 284px;
  height: 447px;
  object-fit: cover;
`;

export const ProductTableSeatToggleWrapper = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  height: 61px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 9;
  pointer-events: none;
`;

export const ProductTableSeatToggle = styled.div<{ selected: boolean }>`
  width: 61px;
  height: 61px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;

  background-image: ${(props) =>
    props.selected
      ? "url(/image-web/order/seat-select.png)"
      : "url(/image-web/order/seat.svg)"};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  color: ${(props) => (props.selected ? "#fff" : "#808080")};
  text-align: center;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const ProductTableSelectTableWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  position: absolute;
  top: 116px;
  left: 50%;
  transform: translateX(-50%);

  > .title {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const ProductTableSelectTableListWrapper = styled.div`
  width: 100%;
  height: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  user-select: none;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const ProductTableSelectTableBackground = styled.div<{ width?: number }>`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: ${(props) => props.width || 47}px;
  height: 67px;
  background: #6436e7;
  border-radius: 7px;
  z-index: 1;
  pointer-events: none;
`;

export const ProductTableSelectTableItem = styled.div<{
  isSelected?: boolean;
  width?: number;
}>`
  width: ${(props) => props.width || 47}px;
  height: 67px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0;
  padding: 0;

  text-align: center;
  font-family: Pretendard;
  font-size: 51px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  ${({ isSelected }) =>
    isSelected
      ? `
        color: #fff;
      `
      : `
        background: linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      `}

  &:hover {
    opacity: 0.8;
  }
`;
